module.exports = __webpack_public_path__ + "static/img/gwzscl.5e1d4fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/gwzscl.png
// module id = w7a3
// module chunks = 0